import { render } from "./ValidationPixKeyForm.vue?vue&type=template&id=4308d981"
import script from "./ValidationPixKeyForm.vue?vue&type=script&lang=js"
export * from "./ValidationPixKeyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__